import styled from 'styled-components';

export const SearchResultsContainer = styled.div`
  margin-top: 3rem;
  margin-bottom: 3rem;

  & .searchInput {
    margin-bottom: 3rem;
  }
  & .searchResultItem {
    width: 100%;
    padding: 20px 0;
    margin: 0;
    border-bottom: 1px solid #d2d1d2;
  }
  & .searchResultItem h3 {
    margin: 0;
    color: #000;
    font-weight: bold;
  }
  & .searchResultItem p {
    font-weight: bold;
    padding-top: 2px;
    display: inline-block;
    margin-bottom: 0;
  }

  & .pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;
    text-align: center;
    margin-top: 3rem;
  }
  & .pagination li {
    padding: 0 20px;
  }
  & .pagination a {
    cursor: pointer;
    color: #1b7bdd;
  }
  & .pagination li.disabled a {
    cursor: default;
    color: #ccc;
  }
  & .pagination li.selected a {
    cursor: default;
    font-weight: 700;
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  background-color: #fff;
  margin: 0;
  padding: 5px 20px 5px 20px;
  height: 40px;
  display: inline-block;
  float: left;
  border: 1px solid #ababab;
  color: #444;
  outline-style: none;
  vertical-align: top;
  font-size: 20px;
`;
